import React, { useState, useEffect } from "react";
import { IoMdArrowBack, IoMdClose } from "react-icons/io";
import { HiOutlinePlus } from "react-icons/hi";
import axiosInstance from "../axiosinstance";
import { useParams } from "react-router-dom"; // Import useParams to get the payment_id from the URL

export default function PaymentHistory({ isSidebarExpanded }) {
  const { payment_id } = useParams(); // Get the payment_id from the URL params
  const [payments, setPayments] = useState([]); // Track all payments
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [paymentHistory, setPaymentHistory] = useState([]); // Track payment history
  const [historyLoading, setHistoryLoading] = useState(false);
  const [historyError, setHistoryError] = useState(null);
  const [selectedPayment, setSelectedPayment] = useState(null); // State to store the selected payment
  const [changeDetails, setChangeDetails] = useState(null); // State to store the change details (Changed_by, changed_on, user_role)

  // Fetch all payments on component mount
  useEffect(() => {
    const fetchPayments = async () => {
      try {
        const response = await axiosInstance.get(`/api/get_recorded_payment`);
        setPayments(response.data.data);
        setLoading(false);

        // If payment_id is available in URL, auto-fetch the history
        if (payment_id) {
          fetchPaymentHistory(payment_id);
          const selected = response.data.data.find(
            (payment) => payment.payment_id === payment_id
          );
          setSelectedPayment(selected); // Set selected payment details
        }
      } catch (error) {
        setError("Failed to fetch payments");
        setLoading(false);
      }
    };

    fetchPayments();
  }, [payment_id]);

  // Fetch history for a specific payment
  const fetchPaymentHistory = async (payment_id) => {
    setHistoryLoading(true);
    setHistoryError(null);

    try {
      const response = await axiosInstance.get(`/${payment_id}`);
      setPaymentHistory(response.data.data); // Save the history in state
      setHistoryLoading(false);

      // Assuming the change details are part of the payment history response:
      if (response.data.data.length > 0) {
        const changeDetailsResponse = response.data.data[0]; // Or fetch it from the relevant field
        setChangeDetails({
          changed_by: changeDetailsResponse.Changed_by,
          changed_on: changeDetailsResponse.changed_on,
          user_role: changeDetailsResponse.user_role,
        });
      }
    } catch (error) {
      setHistoryError("Failed to fetch payment history");
      setHistoryLoading(false);
    }
  };

  // Handle payment click and fetch history for the selected payment
  const handlePaymentClick = (payment) => {
    fetchPaymentHistory(payment.payment_id); // Fetch history for the selected payment
    setSelectedPayment(payment); // Update the selected payment
  };

  const handleBack = () => {
    // Reset states when going back
    setPaymentHistory([]);
    setSelectedPayment(null); // Clear the selected payment when going back
  };

  return (
    <div
      className={`table-container ${
        isSidebarExpanded ? "expanded" : "collapsed"
      }`}
    >
      <div className="table-container-content">
        <div className="main-container page-content">
          <div className="data-lists-content-container page-contents">
            <div className="data-list-content">
              <div className="data-list-header">
                <div className="data-list-header-content">
                  <div className="data-list-heading-content-left-side">
                    Payment History
                  </div>
                  <div className="data-list-heading-content-right-side">
                    <button className="new-button">
                      <HiOutlinePlus className="new-plus-icon" />
                    </button>
                  </div>
                </div>
              </div>
              <div className="data-list-body">
                <div className="data-list-scroll-body">
                  <div className="data-list-table">
                    <table className="table multilevel-data">
                      <thead className="inquiry-head">
                        <tr>
                          <th>
                            <input type="checkbox" />
                          </th>
                          <th>SrNO</th>
                          <th>Client Name</th>
                        </tr>
                      </thead>
                      <tbody className="data-list-scroll-bodys">
                        {loading ? (
                          <tr>
                            <td colSpan="3">Loading...</td>
                          </tr>
                        ) : error ? (
                          <tr>
                            <td colSpan="3">{error}</td>
                          </tr>
                        ) : (
                          payments.map((payment, index) => (
                            <tr
                              className="hoverable-row"
                              key={payment.payment_id}
                              onClick={() => handlePaymentClick(payment)} // Pass the whole payment object
                            >
                              <td>
                                <input type="checkbox" />
                              </td>
                              <td>{index + 1}</td>
                              <td>{payment.client_name}</td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {selectedPayment && paymentHistory.length > 0 && (
            <div className="data-view-popup">
              <div className="data-view">
                <div className="data-view-contant">
                  <div className="data-view-header">
                    <div className="data-view-header-left-side">
                      <div className="user-header-title">
                        <IoMdArrowBack
                          className="back-company"
                          onClick={handleBack}
                        />
                        Payment History for {selectedPayment.invoice_number}
                      </div>
                    </div>
                    <div className="data-view-header-right-side">
                      <div className="view-close-icon">
                        <IoMdClose />
                      </div>
                    </div>
                  </div>
                  <div className="payment-history-body">
                    <div className="payment-history-content">
                      <table className="history-table">
                        <tbody>
                          {historyLoading ? (
                            <tr>
                              <td colSpan="3">Loading...</td>
                            </tr>
                          ) : historyError ? (
                            <tr>
                              <td colSpan="3">{historyError}</td>
                            </tr>
                          ) : (
                            paymentHistory.map((history, index) => (
                              //   <tr key={history.id}>
                              //     {changeDetails && (
                              //       <div className="change-details">
                              //         <h3>Change Details</h3>
                              //         <p>
                              //           <strong>Changed By:</strong>{" "}
                              //           {changeDetails.changed_by}
                              //         </p>
                              //         <p>
                              //           <strong>Changed On:</strong>{" "}
                              //           {changeDetails.changed_on}
                              //         </p>
                              //         <p>
                              //           <strong>User Role:</strong>{" "}
                              //           {changeDetails.user_role}
                              //         </p>
                              //       </div>
                              //     )}
                              //   </tr>
                              <div key={index} className="row">
                                <div className="history-item">
                                  <div>{`Changed_by: ${history.Changed_by}`}</div>
                                  <div>{`Changed_on: ${history.changed_on}`}</div>
                                  <div>{`User_role: ${history.user_role}`}</div>
                                </div>
                              </div>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Display Change Details if available */}
        </div>
      </div>
    </div>
  );
}
